<template>
<div v-if="company" class="CompanyInfo">
	<div class="Col">
		<p>
            {{ company.Name }} {{ company.Type }}
		</p>
		<p>
            <span>Sitz der Gesellschaft:</span>
			<span>{{ company.Address && company.Address.Street }} {{ company.Address && company.Address.House }}</span>
			<span>{{ company.Address && company.Address.PLZ }} {{ company.Address && company.Address.City }}</span>
		</p>
	</div>
	<div class="Col">
        <p>
            <span><span>Tel.&nbsp</span><span></span>{{ company.Phone }}</span>
            <span v-if="company.Fax"><span>Fax&nbsp</span><span></span>{{ company.Fax }}</span>
        </p>
		<p>
			<a :href="'mailto:' + company.Email"><span>{{ company.Email }}</span></a>
			<a :href="company.Site"><span>{{ company.Site }}</span></a>
		</p>
    </div>
    <div class="Col">
        <p>
            <span>Geschäftsführer:</span>
            <span>{{ company.Owners }}</span>
            <span>{{ company.Registration }}</span>
        </p>
    </div>
    <div class="Col">
		<p>
			<span>{{ company.BankDetails && company.BankDetails.BankName }}</span>
            <span class="CompanyInfo-Iban">
                <span>IBAN:&nbsp</span>
				<span>{{ company.BankDetails && company.BankDetails.IBAN }}</span>
            </span>

			<span>BIC: {{ company.BankDetails && company.BankDetails.BIC }}</span>
			<span>USt-IdNr.: {{ company.TaxNumber }}</span>
		</p>
	</div>
</div>
</template>

<script>
export default {
	name: 'CompanyAddress',
	props: {
		company: {
			type: Object,
			default: () => ({
				Name: '',
				Address: { Street: '', House: '', PLZ: '', City: '' },
				Phone: '',
				Fax: '',
				Email: '',
				Site: '',
				Owners: '',
				Registration: '',
				TaxNumber: '',
				BankDetails: { BankName: '', IBAN: '', BIC: '' },
			})
		}
	},
}
</script>

<style lang="scss">
.CompanyInfo {
    position: absolute;
    bottom: 0.5cm;
    left: 2.5cm;
    right: 2.25cm;
    display: flex;
    flex-direction: row;
    font-size: 8pt;

    .Col {
        flex: 1 1 25%;

        & + .Col {
            margin-left: 8px;
        }

        > p {
            margin-top: 15px;

            > span:not(.CompanyInfo-Iban) {
                display: block;
                hyphens: auto;
            }
        }
    }

    &-Iban {
        display: flex;
        align-items: flex-start;
    }

    a {
        text-decoration: none;
        color: black;
        display: block;
    }
}
</style>



// WEBPACK FOOTER //
// CompanyAddress.vue?04185d07